import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../components/seo/Seo';
import { articleSchema, breadcrumbSchema } from '../../components/seo/jsonld';
import GoogleAd from '../../components/GoogleAd';
import { AD_SLOTS } from '../../components/adSlots';

const BlogLayout = ({ post, children }) => (
    <>
        <Seo
            title={`${post.title.replace(/&[a-z]+;/g, "'")} — Blog`}
            description={post.description}
            path={`/blog/${post.slug}`}
            type="article"
            jsonLd={[
                articleSchema({
                    title: post.title.replace(/&[a-z]+;/g, "'"),
                    description: post.description,
                    slug: post.slug,
                    date: post.date,
                }),
                breadcrumbSchema([
                    { name: 'Home', path: '/' },
                    { name: 'Blog', path: '/blog' },
                    { name: post.title.replace(/&[a-z]+;/g, "'"), path: `/blog/${post.slug}` },
                ]),
            ]}
        >
            <meta property="article:published_time" content={post.date} />
            <meta property="article:modified_time" content={post.date} />
        </Seo>

        <div className="page-container narrow">
            <article className="blog-post">
                <header className="page-header">
                    <p className="blog-post-meta">
                        <Link to="/blog">Blog</Link>
                        <span aria-hidden="true"> &middot; </span>
                        <time dateTime={post.date}>
                            {new Date(post.date).toLocaleDateString(undefined, {
                                year: 'numeric', month: 'long', day: 'numeric',
                            })}
                        </time>
                        <span aria-hidden="true"> &middot; </span>
                        <span>{post.readingTime}</span>
                    </p>
                    <h1>{post.title}</h1>
                </header>

                <div className="blog-post-body">{children}</div>

                <GoogleAd slot={AD_SLOTS.BLOG_POST_BOTTOM} className="ad-slot-inline" />

                <footer className="blog-post-footer">
                    <p>
                        &larr; <Link to="/blog">Back to blog</Link>
                    </p>
                </footer>
            </article>
        </div>
    </>
);

export default BlogLayout;
